import React from 'react';
import { FaCog, FaBolt, FaGasPump, FaCheckCircle } from 'react-icons/fa';
import PhoneCTA from './PhoneCTA';
import { WHYUS_SHOWCASE } from '../constants/images';
import './WhyUs.css';

const reasons = [
  'Direct sourcing from OEM suppliers — no middlemen',
  'Every part inspected, tested, and graded by certified technicians',
  'Nationwide network of 200+ verified auto salvage partners',
  'VIN-verified fitment guarantee for your specific vehicle',
  'Same-day dispatch for most in-stock items',
  'Dedicated support team available 6 days a week',
];

const stats = [
  { value: '20+', label: 'Years in Business' },
  { value: '1M+', label: 'Parts in Stock' },
  { value: '50K+', label: 'Happy Customers' },
  { value: '98%', label: 'Satisfaction Rate' },
];

const WhyUs = () => {
  return (
    <section className="whyus">
      <div className="whyus-container">
        <div className="whyus-visual">
          <div className="visual-card main-card">
            <div className="vc-icon"><FaCog /></div>
            <div className="vc-text">
              <strong>Engine — 3.5L V6</strong>
              <span>2019 Toyota Camry</span>
              <span className="vc-badge">In Stock</span>
            </div>
          </div>
          <div className="visual-card sub-card">
            <div className="vc-icon"><FaBolt /></div>
            <div className="vc-text">
              <strong>Alternator</strong>
              <span>2020 Ford F-150</span>
              <span className="vc-badge">Ships Today</span>
            </div>
          </div>
          <div className="visual-card sub-card2">
            <div className="vc-icon"><FaGasPump /></div>
            <div className="vc-text">
              <strong>Fuel Pump Assembly</strong>
              <span>2018 Honda Accord</span>
              <span className="vc-badge">Verified OEM</span>
            </div>
          </div>

          <div className="visual-stats">
            {stats.map((s, i) => (
              <div className="vs-item" key={i}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="whyus-content">
          <div className="section-badge">WHY MAXAUTOPARTS?</div>
          <h2>Why Choose MaxAutoParts<br />for OEM Parts?</h2>
          <p className="whyus-intro">
            Powered by <strong>Opulence Technologies</strong>, MaxAutoParts delivers quality,
            speed, and honesty — every single time you need an auto part.
          </p>

          <ul className="reasons-list">
            {reasons.map((r, i) => (
              <li key={i}>
                <FaCheckCircle className="check-icon" />
                <span>{r}</span>
              </li>
            ))}
          </ul>

          <div className="whyus-actions">
            <a href="#contact" className="btn-primary">Get Started Today</a>
            <PhoneCTA variant="outline" />
            <a href="#faq" className="btn-ghost">Learn More &rarr;</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
